module.exports = __webpack_public_path__ + "img/delete.dd02982c.svg";